function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingPlans2 = function SvgLandingPlans2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18202_16777)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "#4378FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.332 20.6641H27.6654C23.2656 20.6641 21.0657 20.6641 19.6989 22.0309C18.7147 23.015 18.4392 24.431 18.362 26.7891H41.6354C41.5582 24.431 41.2827 23.015 40.2985 22.0309C38.9317 20.6641 36.7318 20.6641 32.332 20.6641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6654 39.3307H32.332C36.7318 39.3307 38.9317 39.3307 40.2985 37.9639C41.6654 36.5971 41.6654 34.3972 41.6654 29.9974C41.6654 29.4818 41.6654 28.9964 41.6632 28.5391H18.3342C18.332 28.9964 18.332 29.4818 18.332 29.9974C18.332 34.3972 18.332 36.5971 19.6989 37.9639C21.0657 39.3307 23.2656 39.3307 27.6654 39.3307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1237 34.6641C22.1237 34.1808 22.5154 33.7891 22.9987 33.7891H27.6654C28.1486 33.7891 28.5404 34.1808 28.5404 34.6641C28.5404 35.1473 28.1486 35.5391 27.6654 35.5391H22.9987C22.5154 35.5391 22.1237 35.1473 22.1237 34.6641Z",
    fill: "#4378FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.707 34.6641C29.707 34.1808 30.0988 33.7891 30.582 33.7891H32.332C32.8153 33.7891 33.207 34.1808 33.207 34.6641C33.207 35.1473 32.8153 35.5391 32.332 35.5391H30.582C30.0988 35.5391 29.707 35.1473 29.707 34.6641Z",
    fill: "#4378FF"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_dii_18202_16777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.18142 24.2888C-0.245184 11.0341 10.4482 0.237371 23.7028 0.173607L38.4051 0.102879C51.6598 0.0391153 62.4565 10.7325 62.5203 23.9871L62.5877 38.0003C62.6514 51.255 51.9581 62.0517 38.7034 62.1155L24.0012 62.1862C10.7465 62.2499 -0.0502428 51.5566 -0.114007 38.3019L-0.18142 24.2888Z",
    fill: "url(#paint0_linear_18202_16777)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_18202_16777",
    x: -4.72561,
    y: -3.7916,
    width: 78.9949,
    height: 76.3609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18202_16777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_18202_16777",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18202_16777"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.54202,
    dy: -3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_18202_16777",
    result: "effect3_innerShadow_18202_16777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18202_16777",
    x1: 10.9327,
    y1: 7.79915,
    x2: 52.8966,
    y2: 53.2442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18202_16777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "white"
  }))));
};
export default SvgLandingPlans2;